import { attributeGetter, Component } from "@bodil/dom/component";
import type { Role } from "aria-attribute-types";
import { html } from "lit";
import { customElement } from "lit/decorators.js";

import styles from "./options-layout.css?inline";

declare global {
    interface HTMLElementTagNameMap {
        "btk-options-layout": BtkOptionsLayout;
    }
}

@customElement("btk-options-layout")
export class BtkOptionsLayout extends Component {
    @attributeGetter get role(): Role {
        return "presentation";
    }

    render() {
        return html`<slot></slot>`;
    }

    static styles = styles;
}
